import React from 'react';
import { Tooltip } from "@material-ui/core";

interface TruncatedTableCellProps {
  text: string;
  truncatedSize: number;
}

const TruncatedTableCell: React.FC<TruncatedTableCellProps> = ({ text, truncatedSize }) => {
  const _maxLength = truncatedSize ? truncatedSize : 20;
  const truncatedText = text.length > _maxLength ? `${text.substring(0, _maxLength - 3)}...` : text;

  return (
    <Tooltip title={text} placement="top" arrow>
      <span>{truncatedText}</span>
    </Tooltip>
  );
};

export default TruncatedTableCell;